export const initPurchase = (purchase = {}) => ({
    ...purchase,
    claimStatus: purchase?.claimStatus || null,
    claimReason: purchase?.claimReason || null,
    claimReasonDetails: purchase?.claimReasonDetails || null,
});
